import { render } from "./NewMachine.vue?vue&type=template&id=c83d840e&scoped=true"
import script from "./NewMachine.vue?vue&type=script&lang=js"
export * from "./NewMachine.vue?vue&type=script&lang=js"

import "./NewMachine.vue?vue&type=style&index=0&id=c83d840e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c83d840e"]])

export default __exports__